document.documentElement.classList.add('js');
document.querySelectorAll('[data-auto-submit]').forEach(select=>{select.addEventListener('change',()=>{if(select.form)select.form.requestSubmit();});});
document.querySelectorAll('[data-mobile-menu]').forEach(menu=>{
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary')?.focus();}});
  menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));
  document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
});

function mountHomeCustomizers(container = document) {
  const roots = [...container.querySelectorAll('[data-home-customizer]')];
  if (container.matches?.('[data-home-customizer]')) roots.unshift(container);
  roots.forEach(root => {
    if (root.dataset.homeCustomizerMounted) return;
    const buttons = [...root.querySelectorAll('[data-home-palette]')];
    const previews = [...root.querySelectorAll('[data-home-preview]')];
    const validButtons = buttons.filter(button => /^[a-z0-9_-]{1,64}$/.test(button.dataset.value || '') && previews.some(preview => preview.dataset.palette === button.dataset.value));
    if (!validButtons.length) return;
    root.dataset.homeCustomizerMounted = 'true';
    const selectPalette = button => {
      const palette = button.dataset.value;
      buttons.forEach(choice => {
        const selected = choice.dataset.value === palette;
        choice.setAttribute('aria-pressed', String(selected));
        choice.classList.toggle('is-active', selected);
      });
      previews.forEach(preview => { preview.hidden = preview.dataset.palette !== palette; });
      root.querySelectorAll('[data-home-palette-label]').forEach(label => { label.textContent = button.dataset.label || palette; });
      const localeRoot = window.Shopify?.routes?.root || '/';
      const parameters = new URLSearchParams({ atelier: 'compose', layout: 'triptych', motif: 'arches', palette });
      root.querySelectorAll('[data-home-customize-link]').forEach(link => {
        link.setAttribute('href', localeRoot.replace(/\/?$/, '/') + 'pages/configurateur?' + parameters.toString());
      });
    };
    root.addEventListener('click', event => {
      const button = event.target.closest?.('[data-home-palette]');
      if (!validButtons.includes(button)) return;
      selectPalette(button);
    });
    selectPalette(validButtons.find(button => button.getAttribute('aria-pressed') === 'true') || validButtons[0]);
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountHomeCustomizers());
else mountHomeCustomizers();
document.addEventListener('shopify:section:load', event => mountHomeCustomizers(event.target));

/* Verified print downloads: keep CDN image negotiation out of manufacturing files. */
(function (global) {
  'use strict';
  const MAX_BYTES = 20 * 1024 * 1024;
  const mounted = new WeakSet();
  function allowedUploadURL(value) {
    try {
      const url = new URL(value);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.port || url.username || url.password || !/^\/s\/files\/[^]+\/uploads\/[^/]+$/.test(url.pathname)) return null;
      url.hash = ''; return url.href;
    } catch (error) { return null; }
  }
  function safeFilename(value, kind) {
    const extension = kind === 'png' ? '.png' : kind === 'zip' ? '.zip' : '.json';
    return /^[a-z0-9][a-z0-9_-]{0,80}\.(png|json|zip)$/i.test(value || '') && value.toLowerCase().endsWith(extension) ? value : 'creation' + extension;
  }
  async function readBoundedBody(response, maxBytes = MAX_BYTES) {
    const declaredSize = Number(response.headers.get('content-length'));
    if (Number.isFinite(declaredSize) && declaredSize > maxBytes) throw new Error('file_too_large');
    if (!response.body?.getReader) {
      const bytes = new Uint8Array(await response.arrayBuffer());
      if (!bytes.length || bytes.length > maxBytes) throw new Error('file_too_large');
      return bytes;
    }
    const reader = response.body.getReader(), chunks = []; let length = 0;
    try {
      for (;;) {
        const part = await reader.read(); if (part.done) break;
        length += part.value.byteLength;
        if (length > maxBytes) { await reader.cancel(); throw new Error('file_too_large'); }
        chunks.push(part.value);
      }
    } finally { reader.releaseLock(); }
    if (!length) throw new Error('invalid_file');
    const bytes = new Uint8Array(length); let offset = 0;
    for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.byteLength; }
    return bytes;
  }
  async function verifyBytes(bytes, kind, contentType, expectedHash, cryptoImpl = global.crypto) {
    if (!(bytes instanceof Uint8Array) || !bytes.length || bytes.length > MAX_BYTES || kind !== 'png' && (!/^[a-f0-9]{64}$/i.test(expectedHash || '') || !cryptoImpl?.subtle)) throw new Error('verification_unavailable');
    const type = (contentType || '').split(';')[0].trim().toLowerCase();
    if (kind === 'png') {
      const signature = [137,80,78,71,13,10,26,10];
      if (type !== 'image/png' || bytes.length < 33 || !signature.every((value, index) => bytes[index] === value) || String.fromCharCode(...bytes.slice(12,16)) !== 'IHDR') throw new Error('original_format_unavailable');
      const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
      if (view.getUint32(8) !== 13 || !view.getUint32(16) || !view.getUint32(20) || view.getUint32(16) > 16000 || view.getUint32(20) > 16000) throw new Error('invalid_file');
      // Shopify may losslessly re-encode previews. Only ZIP archives are manufacturing originals.
      return new Blob([bytes], { type: 'image/png' });
    } else if (kind === 'json') {
      if (!['application/json','application/octet-stream','text/plain'].includes(type)) throw new Error('invalid_file');
      try { JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes)); } catch (error) { throw new Error('invalid_file'); }
    } else if (kind === 'zip') {
      if (!['application/zip','application/octet-stream','application/x-zip-compressed'].includes(type) || bytes.length < 22 || bytes[0] !== 80 || bytes[1] !== 75 || bytes[2] !== 3 || bytes[3] !== 4) throw new Error('invalid_file');
      const end = new DataView(bytes.buffer, bytes.byteOffset + bytes.length - 22, 22);
      if (end.getUint32(0, true) !== 0x06054b50 || end.getUint16(20, true) !== 0) throw new Error('invalid_file');
    } else { throw new Error('invalid_file'); }
    const digest = await cryptoImpl.subtle.digest('SHA-256', bytes);
    const actual = Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
    if (actual !== expectedHash.toLowerCase()) throw new Error('original_hash_mismatch');
    return new Blob([bytes], { type: kind === 'zip' ? 'application/zip' : 'application/json' });
  }
  async function retrieveOriginal({ url, kind, sha256 }, fetchImpl = global.fetch, cryptoImpl = global.crypto) {
    const allowed = allowedUploadURL(url);
    if (!allowed || !['png','json','zip'].includes(kind) || kind !== 'png' && (!/^[a-f0-9]{64}$/i.test(sha256 || '') || !cryptoImpl?.subtle) || typeof fetchImpl !== 'function') throw new Error('verification_unavailable');
    const controller = new AbortController(), timer = global.setTimeout(() => controller.abort(), 45000);
    try {
      const response = await fetchImpl(allowed, { headers: { Accept: kind === 'png' ? 'image/png' : kind === 'zip' ? 'application/zip, application/octet-stream' : 'application/json' }, credentials: 'omit', mode: 'cors', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal });
      if (!response.ok || response.url && !allowedUploadURL(response.url)) throw new Error('file_unavailable');
      const bytes = await readBoundedBody(response);
      return await verifyBytes(bytes, kind, response.headers.get('content-type'), sha256, cryptoImpl);
    } finally { global.clearTimeout(timer); }
  }
  function saveBlob(blob, filename) {
    const url = global.URL.createObjectURL(blob), anchor = document.createElement('a');
    anchor.href = url; anchor.download = filename; anchor.hidden = true;
    document.body.append(anchor); anchor.click(); anchor.remove();
    global.setTimeout(() => global.URL.revokeObjectURL(url), 30000);
  }
  function mount(container = document) {
    const rows = Array.from(container.querySelectorAll('.cart-row'));
    if (container.matches?.('.cart-row')) rows.unshift(container);
    rows.forEach(row => {
      if (mounted.has(row) || !row.querySelector('[data-print-download]')) return;
      mounted.add(row); let busy = false;
      row.addEventListener('click', async event => {
        const link = event.target.closest?.('[data-print-download]');
        if (!link || !row.contains(link)) return;
        event.preventDefault(); if (busy) return;
        const status = row.querySelector('[data-print-download-status]');
        if (!status) return;
        busy = true; status.textContent = 'Préparation du téléchargement…';
        link.setAttribute('aria-busy', 'true');
        try {
          const kind = link.dataset.printKind, blob = await retrieveOriginal({ url: link.getAttribute('href'), kind, sha256: link.dataset.printSha256 });
          saveBlob(blob, safeFilename(link.dataset.printFilename, kind));
          status.textContent = kind === 'png' ? 'Aperçu téléchargé. Les originaux sont dans les archives de fabrication.' : kind === 'zip' ? 'Archive originale vérifiée. Téléchargement démarré.' : 'Récapitulatif vérifié. Téléchargement démarré.';
        } catch (error) {
          status.textContent = ['original_hash_mismatch','original_format_unavailable'].includes(error.message) ? 'Le fichier original n’a pas pu être vérifié. Contactez-nous.' : 'Le fichier n’a pas pu être récupéré. Réessayez ou contactez-nous.';
        } finally { busy = false; link.removeAttribute('aria-busy'); }
      });
    });
  }
  const api = { allowedUploadURL, safeFilename, readBoundedBody, verifyBytes, retrieveOriginal, mount };
  global.SourdinePrintDownloads = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
